import { Alert } from "antd";
import * as React from "react";
import { getErrorMessage } from "src/common/onError";
import { PropsTableError } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";

import * as styles from "./common.module.less";

/**
 * Компонент отображения ошибки в таблице
 */
export const TableError = ({ error }: PropsTableError) => (
  <div className={styles.box}>
    <Alert type="error" showIcon {...getErrorMessage(error)} />
  </div>
);
